import IlluminateMain from "./IlluminateMain";

export default IlluminateMain;
